import header from "./header.json";
import navbar from "./navbar.json";

export const navES_MX = {
	header,
	navbar,
};
